import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  get text() {
    return this.data.get('text')
  }

  copy() {
    navigator.clipboard.writeText(this.text)
  }
}
